import React, { useState } from "react";
import { FilterMatchMode } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../schools/SchoolsTable.css";

export default function AssessmentTable({ assessments }) {
  return (
    <div className="datatable">
      <DataTable
        value={assessments}
        emptyMessage="No assessments found."
        tableStyle={{ minWidth: "100%", fontSize: 12 }}
      >
        <Column
          field="subjectTitle"
          header="Subject Title"
          sortable
          style={{ width: "30%" }}
        ></Column>
        <Column
          field="ca1"
          header="CA 1"
          sortable
          style={{ width: "5%" }}
        ></Column>
        <Column
          field="ca2"
          header="CA 2"
          sortable
          style={{ width: "5%" }}
        ></Column>
        <Column
          field="exam"
          header="Exam"
          sortable
          style={{ width: "5%" }}
        ></Column>
        <Column
          field="total"
          header="Total"
          sortable
          style={{ width: "10%" }}
        ></Column>
        <Column
          field="grade"
          header="Grade"
          sortable
          style={{ width: "5%" }}
        ></Column>
        <Column
          field="remark"
          header="Remark"
          sortable
          style={{ width: "10%" }}
        ></Column>
        <Column
          field="classAverage"
          header="Class Average"
          sortable
          style={{ width: "5%" }}
        ></Column>
        <Column
          field="classMaxValue"
          header="Class Max. Value"
          sortable
          style={{ width: "10%" }}
        ></Column>
        <Column
          field="classMinValue"
          header="Class Min. Value"
          sortable
          style={{ width: "5%" }}
        ></Column>
      </DataTable>
    </div>
  );
}
